import { render, staticRenderFns } from "./ProcurementType.vue?vue&type=template&id=e27f9d70"
import script from "./ProcurementType.vue?vue&type=script&lang=js"
export * from "./ProcurementType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports